/**
* @author Camilo
* @since  16/11/2017
**/
export class NotaSaveModel{
    constructor(public id:MchNotasId, public cnumcont:string, public ciddoc:string, public cnumdoc:string, public ctiponota:string, public dfecmov:string, public nvalbase:number, public nvaliva:number,public nidreg:number,public nvalimpuestoconsumo:number, public cusuario:string, public vobservacion:string, public unidades:number,public ncodigoconceptonota:string){}
    
}

export class MchNotasId{
	constructor(public cid:string, public ccodcon:string,public nregconcep:number){}
}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Notas/NotaSave.model.ts